function CalendarVector() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			fill="none"
			viewBox="0 0 14 14"
		>
			<g clipPath="url(#clip0_3614:9721)">
				<path
					fill="#B5DBFF"
					d="M.469 11.201v1.867c0 .515.418.933.933.933h11.2a.933.933 0 00.933-.933V11.2H.47z"
				></path>
				<path
					fill="#97D0FF"
					d="M12.886 11.2v1.866a.933.933 0 01-.933.933h.648a.933.933 0 00.933-.933v-1.867h-.648z"
				></path>
				<path
					fill="#EDF5FF"
					d="M.469 3.732v8.4c0 .516.418.934.933.934h11.2a.933.933 0 00.933-.934v-8.4H.47z"
				></path>
				<path
					fill="#D5E8FE"
					d="M12.886 3.734v8.4a.933.933 0 01-.933.934h.648a.933.933 0 00.933-.934v-8.4h-.648z"
				></path>
				<path
					fill="#FF435B"
					d="M13.535 4.2V1.867a.933.933 0 00-.933-.933h-11.2a.933.933 0 00-.933.933V4.2h13.066z"
				></path>
				<path
					fill="#E3374E"
					d="M3.272 2.079h-.467a.211.211 0 010-.423h.467a.211.211 0 010 .423zM4.667 2.077h-.466a.211.211 0 010-.423h.466a.211.211 0 010 .423zM9.804 2.077h-.467a.211.211 0 010-.423h.467a.211.211 0 010 .423zM11.205 2.079h-.466a.211.211 0 110-.423h.466a.211.211 0 110 .423z"
				></path>
				<path
					fill="#596C76"
					d="M3.27 1.867a.467.467 0 00.933 0v-1.4a.467.467 0 00-.933 0v1.4zM9.805 1.867a.467.467 0 00.933 0v-1.4a.467.467 0 10-.933 0v1.4z"
				></path>
				<path
					fill="#E3374E"
					d="M12.602.934h-.648c.516 0 .933.417.933.933V4.2h.648V1.867a.933.933 0 00-.933-.933z"
				></path>
				<path
					fill="#E3374E"
					d="M.469 3.057h13.066v.422H.47v-.422z"
				></path>
				<path
					fill="#596C76"
					d="M7.238 7.352c0-.965-.785-1.75-1.75-1.75s-1.75.785-1.75 1.75a.467.467 0 10.934 0 .818.818 0 011.633 0c0 .45-.366.816-.817.816a.467.467 0 100 .934.818.818 0 010 1.633.818.818 0 01-.816-.817.467.467 0 10-.934 0c0 .965.785 1.75 1.75 1.75s1.75-.785 1.75-1.75c0-.506-.216-.963-.562-1.283.346-.32.562-.777.562-1.283zM9.48 5.635a.467.467 0 00-.508.101l-.933.934a.467.467 0 10.66.66l.137-.137V11.2a.467.467 0 10.933 0V6.066a.467.467 0 00-.288-.43z"
				></path>
			</g>
			<defs>
				<clipPath id="clip0_3614:9721">
					<path fill="#fff" d="M0 0H14V14H0z"></path>
				</clipPath>
			</defs>
		</svg>
	);
}

export default CalendarVector;
